import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const FormFieldPassword = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  errorMessage,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="input-container">
      <label htmlFor={name}>{label}</label>
      <div className="password-wrapper">
        <input
          autoComplete="current-password"
          name={name}
          id={name}
          placeholder={placeholder}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e)}
          {...props}
        />

        <div className="icon-wrapper">
          <FontAwesomeIcon
            icon={showPassword ? faEye : faEyeSlash}
            onClick={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className="error-msg">{errorMessage}</div>
    </div>
  );
};

export default FormFieldPassword;
